const valueFromObjPath = (value: string, object: object) =>
  value.split('.').reduce((obj, key) => obj[key], object);

export default valueFromObjPath;
